export default __webpack_public_path__ + "static/image-vps-f2bd34a787cd1d01ef7d6e4b7df783ea.png";